<template>
  <Head title="Connection Status List" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <connection-status-list :connections="connections" :num_connections="num_connections" :num_errors="num_errors"></connection-status-list>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  connections: Array,
  num_connections: Number,
  num_errors: Number
});
</script>

